import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {LoadingIndicatorComponent} from './loading-indicator.component';
import {RouteLoadingIndicatorService} from './route-loading-indicator.service';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        LoadingIndicatorComponent
    ],
    exports: [
        LoadingIndicatorComponent
    ],
    providers: [
        RouteLoadingIndicatorService
    ]
})
export class LoadingIndicatorModule {}
